import { render, staticRenderFns } from "./AdminShippingAddDialog.vue?vue&type=template&id=44feba1c&"
import script from "./AdminShippingAddDialog.vue?vue&type=script&lang=js&"
export * from "./AdminShippingAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdminShippingAddDialog.vue?vue&type=style&index=0&id=44feba1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports